const getUrlVariable = (key) => {
	const { location: { search } } = window;
	const searchParams = new URLSearchParams(search);

	if (!searchParams.has(key)) {
		return false;
	}

	return searchParams.get(key);
};

const getAllUrlVariables = () => {
	const { location: { search } } = window;
	const searchParams = new URLSearchParams(search);
	const variables = {};

	for (const pair of searchParams.entries()) {
		const [key, value] = pair;

		variables[key] = value;
	}

	return variables;
};

export {
	getUrlVariable,
	getAllUrlVariables,
};
